import api from './api';
import { ApiResponse } from '../types';

export interface DailyAnswerCount {
  date: string;  // yyyy-MM-dd
  count: number;
}

export interface SchoolStat {
  schoolId: number;
  schoolName: string;
  answerCount: number;
}

export interface SchoolParticipationBucket {
  hot: SchoolStat[];
  medium: SchoolStat[];
  cold: SchoolStat[];
}

export interface CompletionStatusPie {
  completed: number;
  inProgress: number;
  pending: number;
}

export interface GradeSlice {
  grade: string;
  count: number;
}

export interface GradeDistribution {
  slices: GradeSlice[];
}

export interface QuestionnaireWithAnswers {
  questionnaireId: number;
  title: string;
  answerCount: number;
}

export const siteStatisticsService = {
  /** 每日答卷量趋势。[from, to) 闭开区间，yyyy-MM-dd */
  getDailyAnswers: async (
    from: string,
    to: string,
    schoolId?: number,
    questionnaireId?: number
  ): Promise<DailyAnswerCount[]> => {
    const resp = await api.get<ApiResponse<DailyAnswerCount[]>>(
      '/admin/site-statistics/daily-answers',
      { params: { from, to, schoolId, questionnaireId } }
    );
    return resp.data.data;
  },

  /** 学校参与三段位（按答卷量降序切热门/中等/冷门） */
  getSchoolParticipation: async (
    academicYear?: string
  ): Promise<SchoolParticipationBucket> => {
    const resp = await api.get<ApiResponse<SchoolParticipationBucket>>(
      '/admin/site-statistics/school-participation',
      { params: { academicYear } }
    );
    return resp.data.data;
  },

  /** 单问卷（可选学校）完成状态饼图 */
  getCompletionStatus: async (
    questionnaireId: number,
    schoolId?: number
  ): Promise<CompletionStatusPie> => {
    const resp = await api.get<ApiResponse<CompletionStatusPie>>(
      '/admin/site-statistics/completion-status',
      { params: { questionnaireId, schoolId } }
    );
    return resp.data.data;
  },

  /** 该学校有答卷数据的问卷下拉列表（按答卷量降序）。
   *  替代 /admin/questionnaires?schoolId=X —— 后者按问卷归属学校过滤，
   *  对中心化创建的问卷会返回空。 */
  getQuestionnairesBySchool: async (
    schoolId: number
  ): Promise<QuestionnaireWithAnswers[]> => {
    const resp = await api.get<ApiResponse<QuestionnaireWithAnswers[]>>(
      '/admin/site-statistics/questionnaires-by-school',
      { params: { schoolId } }
    );
    return resp.data.data;
  },

  /** 单问卷（可选学校）年级分布饼图 */
  getGradeDistribution: async (
    questionnaireId: number,
    schoolId?: number
  ): Promise<GradeDistribution> => {
    const resp = await api.get<ApiResponse<GradeDistribution>>(
      '/admin/site-statistics/grade-distribution',
      { params: { questionnaireId, schoolId } }
    );
    return resp.data.data;
  },
};
